export const practice = {
  name: 'Lima Dental Group',
  doctor: 'Dr. Julio Lima, DDS',
  phone: '(305) 556-2383',
  phoneHref: 'tel:+13055562383',
  email: 'info@lima.dental',
  url: 'https://lima.dental',
  /** Single booking destination for every booking CTA (Dental Intel via lima.dental). */
  bookingUrl: 'https://lima.dental',
  since: '1989',
  address: {
    street: '15600 NW 67th Ave #106',
    city: 'Miami Lakes',
    region: 'FL',
    postalCode: '33014',
  },
  /** Full, literal address string — used by MANGO and structured data. */
  fullAddress: '15600 NW 67th Ave #106, Miami Lakes, FL 33014',
  hours: [
    { day: 'Monday to Friday', value: '8:00 AM – 5:00 PM' },
    { day: 'Saturday', value: 'By appointment only' },
    { day: 'Sunday', value: 'Closed' },
  ],
  languages: 'Lima Dental Group provides care in English and Spanish.',
  walkIns: 'Walk-ins are welcome at Lima Dental Group.',
  newPatients: 'Lima Dental Group is accepting new patients.',
  mapsUrl:
    'https://www.google.com/maps/search/?api=1&query=15600+NW+67th+Ave+%23106+Miami+Lakes+FL+33014',
}

/**
 * Verified reviews from the "Lima Dental Miami Lakes" Google Business profile.
 * TODO: replace `url` with the official Google Business Profile review link
 * when it is supplied. Until then this points to the Google Maps search result
 * for the practice — no invented URL.
 */
export const googleReviews = {
  rating: '4.9',
  count: 174,
  url: 'https://www.google.com/maps/search/?api=1&query=Lima+Dental+Miami+Lakes',
}

/** Single-page navigation: every link is an anchor on this landing page. */
export const navItems = [
  { label: 'Services', href: '#services' },
  { label: 'Invisalign', href: '#invisalign' },
  { label: 'Results', href: '#results' },
  { label: 'Financing', href: '#financing' },
  { label: 'Dr. Lima', href: '#dr-lima' },
  { label: 'Patient Info', href: '#patient-info' },
  { label: 'Emergency', href: '#emergency', accent: true },
  { label: 'Contact', href: '#contact' },
]
